import { render, staticRenderFns } from "./v-turnstile.vue?vue&type=template&id=7c4662c0&"
import script from "./v-turnstile.vue?vue&type=script&lang=js&"
export * from "./v-turnstile.vue?vue&type=script&lang=js&"
import style0 from "./v-turnstile.vue?vue&type=style&index=0&id=7c4662c0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports